import { MapEvent } from './map-event';
import { MapEventType } from './map-event-type';

export class MouseMoveMapEvent implements MapEvent {
    type: MapEventType = MapEventType.mouseMove;
    constructor(public payload: mapboxgl.MapMouseEvent) {}
}
